"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeGetMyDataResponse = exports.normalizeDocType = void 0;
const next12_utils_common_1 = require("@gcloud-npm/next12.utils.common");
const normalizeDocType = (telcoDocType) => {
    const docTypeObject = {
        docTypeCode: -1,
        docTypeText: null,
    };
    telcoDocType = telcoDocType.replace(/-|_/g, "");
    if (telcoDocType.toLowerCase() === "nif") {
        docTypeObject.docTypeCode = 1;
        docTypeObject.docTypeText = "NIF";
    }
    else if (telcoDocType.toLowerCase() === "cif") {
        docTypeObject.docTypeCode = 2;
        docTypeObject.docTypeText = "CIF";
    }
    else if (telcoDocType.toLowerCase() === "nie") {
        docTypeObject.docTypeCode = 3;
        docTypeObject.docTypeText = "NIE";
    }
    else if (telcoDocType.toLowerCase() === "pasa" ||
        telcoDocType.toLowerCase() === "pass" ||
        telcoDocType.toLowerCase() === "pasaporte") {
        docTypeObject.docTypeCode = 4;
        docTypeObject.docTypeText = "Pasaporte";
    }
    return docTypeObject;
};
exports.normalizeDocType = normalizeDocType;
const normalizeGetMyDataResponse = (clientInfo) => {
    const findContacts = (contactsForms, billingDirection) => {
        let smsContactPhone = {
            contactType: "SMS",
            value: "",
            contactTypeTCOL: "2",
            favourite: true,
            advertisingUse: false,
            address: {
                id: "",
                locationFullAddress: "",
            },
        };
        let contactPhone;
        let contactEmail = {
            contactType: "Correo Electrónico",
            value: "",
            contactTypeTCOL: "4",
            favourite: true,
            advertisingUse: false,
            address: {
                id: "",
                locationFullAddress: "",
            },
        };
        let billingDirectionId = "";
        let billingDirectionFullAddress = "";
        if (billingDirection) {
            const { id, locationFullAddress } = billingDirection;
            billingDirectionId = id;
            billingDirectionFullAddress = locationFullAddress;
        }
        const contactAddress = {
            contactId: billingDirectionId,
            value: billingDirectionFullAddress,
        };
        let hasFavoriteSmsContactPhone = false;
        contactsForms.forEach((elem) => {
            const { contactTypeTCOL, favourite } = elem;
            if (contactTypeTCOL === "1" && favourite) {
                contactPhone = elem;
            }
            else if (contactTypeTCOL === "2" && favourite) {
                smsContactPhone = elem;
                hasFavoriteSmsContactPhone = true;
            }
            else if (contactTypeTCOL === "4") {
                if (favourite) {
                    contactEmail = elem;
                }
                else if (!contactEmail.value) {
                    contactEmail = elem;
                }
            }
            else if (contactTypeTCOL === "5" && favourite) {
                contactAddress.contactId = elem.address.id;
                contactAddress.value = elem.address.locationFullAddress;
            }
        });
        const contacts = {
            contactPhone: hasFavoriteSmsContactPhone
                ? smsContactPhone
                : contactPhone || smsContactPhone,
            contactEmail,
            contactAddress,
        };
        return contacts;
    };
    const normalizeCustomerAccounts = (customerAccounts) => {
        let accounts = "";
        if (customerAccounts) {
            accounts = customerAccounts.map((elem) => {
                return {
                    customerAccount: elem.spanishIbanAccountNumber,
                    customerAccountName: elem.customerAccountName,
                    customerAccountId: elem.customerAccountId,
                };
            });
        }
        return accounts;
    };
    const { xcol, contactsForms, permanentResidence: billingDirection, name, firstSurName, secondSurName, companyName, documentType, numberDocument, customerAccounts, } = clientInfo;
    if (xcol) {
        (0, next12_utils_common_1.setCookie)("XCOL", xcol, 1, ".movistar.es", false);
    }
    const { contactEmail, contactPhone, contactAddress } = findContacts(contactsForms, billingDirection);
    const { docTypeCode, docTypeText } = (0, exports.normalizeDocType)(documentType);
    const normalizedClientInfo = {
        name,
        firstSurname: firstSurName,
        secondSurname: secondSurName,
        companyName,
        docType: docTypeCode,
        docTypeText,
        docNumber: numberDocument,
        contactEmail,
        contactPhone,
        contactAddress,
        accounts: normalizeCustomerAccounts(customerAccounts),
        additionalInfo: contactsForms,
        xcol,
    };
    return normalizedClientInfo;
};
exports.normalizeGetMyDataResponse = normalizeGetMyDataResponse;
//# sourceMappingURL=index.js.map